module.exports = __webpack_public_path__ + "static/media/polytope_52_3_3_layers_5_5.793215e7.gif";